import React from "react";

export default function ProfileField({ label, children }) {
  return (
    <label>
      {label}
      {children}
    </label>
  );
}
